var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAddFolder48Line = function SvgIconAddFolder48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7 13.169v-5.37h-3.4v5.37h-5.37v3.4h5.37v5.37h3.4v-5.37h5.37v-3.4H37.7ZM34.3 30.899a1.9 1.9 0 0 1-1.9 1.9H15.6a1.9 1.9 0 0 1-1.9-1.9v-13.8c0-1.05.85-1.9 1.9-1.9h2.29c.6 0 1.18.29 1.53.78l2.06 2.82c.32.44.83.7 1.37.7h3.87v-3.4h-3.01l-1.55-2.12c-1-1.36-2.59-2.17-4.27-2.17H15.6a5.31 5.31 0 0 0-5.3 5.3v13.8c0 2.92 2.38 5.3 5.3 5.3h16.8c2.92 0 5.3-2.38 5.3-5.3v-5.26h-3.4v5.26-.01Z",
    fill: "current"
  })));
};
export default SvgIconAddFolder48Line;